import React from 'react';
import PropTypes from 'prop-types';
import './PanelClaro.scss';

const PanelClaro = ({ sectionName, children }) => (
  <section id={sectionName} className="panelClaro">
    <div className="externalPanel">
      <div className="lightPanel">{children}</div>
    </div>
  </section>
);

PanelClaro.propTypes = {
  sectionName: PropTypes.string,
  children: PropTypes.node,
};

export default PanelClaro;
